<template>
  <div :class="chatStyle">
    <div class="chat">
      <!-- 連線中斷提示：斷線時訊息不會進來，一定要讓使用者看得到 -->
      <div class="signalr-banner" v-if="isReconnecting">
        連線中斷，正在重新連線…
      </div>
      <div class="chat-header clearfix">
        <img
          :src="roomInfo.Image"
          onerror="onerror=null;src='../static/img/avatar-default.jpg'"
          class="avatar"
        />
        <div class="chat-about">
          <div class="chat-with" style="cursor: pointer" @click="OpenLeadUrl">
            {{ roomInfo.RoomName }}
            <span
              class="full-name"
              v-if="roomInfo.LeadCname != roomInfo.RoomName"
              >{{ roomInfo.LeadCname }}</span
            >
          </div>
          <div class="chat-tag" v-show="roomInfo.TagName !== null">
            {{ roomInfo.TagName }}
          </div>
          <div class="classData" v-show="roomInfo.ClassData !== null">
            <p>{{ classData }}</p>
          </div>
        </div>
        <div
          class="salesName mainSales"
          v-if="roomInfo.MainContactName !== null"
        >
          <img
            src="../assets/account_box.png"
            class="chat-header-sales"
            width="24"
            height="24"
          />
          {{ roomInfo.MainContactName }}
        </div>
        <div
          class="salesName mainSales"
          v-else="roomInfo.MainContactName === null"
        >
          【無主聯業務】
        </div>
        <div class="salesName" style="cursor: pointer">
          <img
            src="../assets/headset_mic.png"
            class="chat-header-sales"
            width="24"
            height="24"
            @click="OpenURL"
          />
          {{ staffInfo.StaffName }}
        </div>
      </div>

      <!-- end chat-header -->
      <chat-log :messages="messages"></chat-log>
      <tool-bar :roomInfo="roomInfo" :staffInfo="staffInfo"></tool-bar>
      <message-input></message-input>
      <!-- end chat-message -->
    </div>
    <!-- end chat -->
  </div>
  <!-- end container -->
</template>


<script>
import "signalr";
import ChatLog from "@/components/ChatLog";
import MessageInput from "@/components/MessageInput";
import ToolBar from "@/components/ToolBar";
import Global from "@/components/Global";
import { isMobile } from "mobile-device-detect";
import { ChatContainerHandler } from "@/handler/ChatContainerHandler.js";
import {
  SignalrConnectionHandler,
  SignalrStatus,
} from "@/handler/SignalrConnectionHandler.js";
import store from "@/vuex/store_chat.js";

export default {
  name: "chat-container",
  components: {
    ChatLog,
    MessageInput,
    ToolBar,
  },

  data() {
    return {
      staffInfo: [],
      roomInfo: [],
      messages: [],
      sessionId: "",
      isMobile,
      conn: [],
      chatStyle: "chat-container clearfix ", //聊天室樣式
      token: "",
      isAlert: false,
      maxTime: 90,
      runTime: 90,
      connStatus: null,
      // 存在 this 上，beforeDestroy 才清得掉。放區域變數的話元件銷毀後
      // 閒置計時器會繼續倒數，最後把刻意停掉的連線復活成殭屍。
      idleTimerId: null,
      idleActivityHandler: null,
    };
  },
  computed: {
    isReconnecting() {
      return this.connStatus === SignalrStatus.reconnecting;
    },
    classData() {
      let classdata = this.roomInfo.ClassData;
      if (classdata !== null && classdata !== undefined) {
        return (
          this.roomInfo.ClassData.ListClass +
          " (" +
          this.roomInfo.ClassData.ListClassName +
          ")"
        );
      }
    },
    // messages() {
    //   var message = store.state.messages;
    //   for (var i = 0; i < message.length; i++) {
    //     message[i].msgTime = this.convertUTCDateToLocalDate(
    //       message[i].msgTime
    //     );
    //   }

    //   return message;
    // }
  },
  created() {
    if (this.$route.path == "/MainChat") {
      this.chatStyle = "chat-container clearfix forMain";
    }

    var valid = this.checkKey();

    if (!valid) {
      return false;
    }
    this.token = this.$route.query.token;
    this.initdata(this.token);

    const self = this;
    if (!isMobile) {
      //頁面閒置處理
      // 保留 handler 參照，beforeDestroy 才能只移除自己這一個
      // （不能用匿名函式，也不該用共用 namespace 以免誤殺其他實例的 handler）
      this.idleActivityHandler = function (e) {
        self.runTime = self.maxTime; // reset
      };
      $("body").on("keydown mousemove mousedown", this.idleActivityHandler);
      self.StartIdleTimer();
    }
  },
  mounted() {
    if (isMobile) {
      window.addEventListener("focus", this.handleWinFocus);
    }
  },
  // 元件銷毀時要把連線和所有計時器/監聽一起收掉。
  //
  // 連線：SignalrConnectionHandler 會無限退避重連，沒停的話 SPA route 切換後
  // 會留下永遠重連的殭屍連線，而且每次重連都會再跑一次 onConnected
  // （AddGroup / GetDataByToken），觸發 server 端的單一登入檢查去 closepage
  // 掉當前活著的那條連線。
  //
  // 閒置計時器：不清掉的話會精準抵銷上面停連線的動作 —— 已銷毀的實例繼續
  // 倒數，時間到跳出「頁面閒置過久」（element-ui 的 $alert 是全域服務，
  // 元件銷毀後照樣彈），使用者按確認就執行 conn.start()，stopped 旗標被
  // 重設，剛停掉的連線復活成殭屍。
  beforeDestroy() {
    window.removeEventListener("focus", this.handleWinFocus);
    if (this.idleTimerId) {
      clearInterval(this.idleTimerId);
      this.idleTimerId = null;
    }
    if (this.idleActivityHandler) {
      $("body").off("keydown mousemove mousedown", this.idleActivityHandler);
      this.idleActivityHandler = null;
    }
    if (this.conn && typeof this.conn.stop === "function") {
      this.conn.stop();
    }
  },
  methods: {
    // 閒置計時器：使用者有操作就重置 runTime，歸零代表閒置過久。
    // interval id 一定要存在 this 上，beforeDestroy 才清得掉。
    StartIdleTimer() {
      console.log("StartIdleTimer");
      const self = this;
      this.runTime = this.maxTime;
      if (this.idleTimerId) {
        clearInterval(this.idleTimerId);
      }
      this.idleTimerId = setInterval(function () {
        self.runTime--;
        //console.log(self.runTime);
        if (self.runTime <= 0) {
          self.IdleTimeout();
          clearInterval(self.idleTimerId);
          self.idleTimerId = null;
        }
      }, 1000);
    },
    OpenLeadUrl: function () {
      ChatContainerHandler.OpenURL(this.roomInfo.LeadUrl);
    },
    OpenURL() {
      var url = "/#/Chat?token=" + this.$route.query.token;
      ChatContainerHandler.OpenURL(url);
    },
    // 閒置逾時：由使用者無操作觸發，主動停止連線並要求確認後才重連。
    // 這條路徑跟網路斷線無關 —— 網路斷線由 SignalrConnectionHandler 自動重連。
    IdleTimeout() {
      console.log("IdleTimeout");
      const self = this;
      if (this.isAlert) {
        return;
      }

      this.conn.stop();
      this.$alert("頁面閒置過久,確認後重新整理頁面", "提示", {
        confirmButtonText: "確認",
        type: "warning",
        center: true,
        callback: (action) => {
          self.isAlert = false;
          self.conn.start();
          self.StartIdleTimer();
        },
      });
      this.isAlert = true;
    },
    handleWinFocus() {
      // 視窗回到前景時，如果連線已斷就立刻補一次重連，
      // 不用等退避排程，也不該把網路斷線誤報成閒置逾時。
      // initdata 失敗時 conn 仍是初始值，所以要先確認建立成功。
      if (this.conn && typeof this.conn.ensureConnected === "function") {
        this.conn.ensureConnected();
      }
    },
    checkKey: function () {
      var token = this.$route.query.token;
      var valid = ChatContainerHandler.CheckToken(token);

      return valid;
    },
    initdata: function (token) {
      try {
        this.conn = SignalrConnectionHandler.Create({
          url: this.$conf.MessageAPI + "/signalr",
          hub: "chatHub",
          // 首次連線與每次重連成功後都要重新取資料並重新加入聊天室
          onConnected: function (proxy) {
            proxy.invoke("GetDataByToken", token);
          },
          onStatusChange: (status) => {
            this.connStatus = status;
          },
        });
        Global.proxy = this.conn.proxy;

        this.conn.start();
      } catch (error) {
        alert(error);
        console.log(error);
      }

      //驗證鑰匙
      Global.proxy.on("checkKey", (data) => {
        if (data.status) {
          Global.current_roomid = data.roomId;
          Global.current_staffid = data.staffId;
          this.sessionId = data.chatsessionId;

          //加入對話
          Global.proxy.invoke(
            "joinRoom",
            Global.current_roomid,
            Global.current_staffid,
            this.sessionId
          );
        }
      });

      Global.proxy.on("joinRoom", (user) => {
        this.staffInfo = user;

        //顯示訊息記錄
        //ChatContainerHandler.GetChatHistory();

        $.ajax({
          url: this.$conf.MessageAPI + "/Chat/GetChatHistory",
          type: "post",
          data: {
            roomId: Global.current_roomid,
            staffId: Global.current_staffid,
          },
          dataType: "json",
          success: function (data) {
            for (var i = 0; i < data.length; i++) {
              data[i].msgTime = this.convertUTCDateToLocalDate(data[i].msgTime);
            }
            this.messages = data;
          }.bind(this),
          error: function (a, b, c) {
            //window.location.href = "/#/Error";
          },
        });

        //檢查權限
        Global.proxy.invoke("CheckSpeaker", Global.current_roomid);
        Global.proxy.on("checkSpeaker", (speaker) => {
          store.dispatch("CheckSpeaker", speaker);
        });
      });

      //返回房間資訊
      Global.proxy.on("showGroupRoom", (room) => {
        if (room != null) {
          Global.current_roomid = room.RoomId;
          this.roomInfo = room;
        }
      });

      //推播訊息
      Global.proxy.on("showGroupByRoomMsg", (data) => {
        if (data.RoomId == Global.current_roomid) {
          this.messages.push({
            frmId: data.frmId,
            UserName: data.UserName,
            Text: data.Text,
            msgTime: this.convertUTCDateToLocalDate(data.msgTime),
            msgType: data.msgType,
            filePath: data.filePath,
            previewImageUrl: data.previewImageUrl,
            senderType: data.senderType,
          });
        }
      });

      //訊息提示
      Global.proxy.on("showMessage", (data) => {
        this.$message({
          message: data,
        });
      });

      // //標題閃爍
      // Global.proxy.on("blinkTitle", data => {
      //   blinkTitle("[New Message]", "[新訊息]", 1000, true);
      // });

      //關閉頁面
      Global.proxy.on("closepage", (data) => {
        this.conn.stop();
        window.location.href = "/#/TextInfo";
      });
    },
  },
};
</script>

<style scoped>
.signalr-banner {
  padding: 6px 12px;
  background-color: #fdf6ec;
  color: #e6a23c;
  border-bottom: 1px solid #f5dab1;
  font-size: 13px;
  text-align: center;
}
</style>




// WEBPACK FOOTER //
// src/components/ChatContainer.vue